const faqData = {
  advertisement:[
    {
      id:1,
      title:'Services types?',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:2,
      title:'How you will get your service?',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:3,
      title:'Are custom plan available?',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:4,
      title:'payment system',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:5,
      title:'Payment return',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
  ],
  liveTv:[
    {
      id:1,
      title:'Services types?',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:2,
      title:'How you will get your service?',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:3,
      title:'Are custom plan available?',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:4,
      title:'payment system',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
    {
      id:5,
      title:'Payment return',
      description:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Explicabo accusantium quos beatae velit praesentium labore sint quasi ratione provident saepe.'
    },
  ],
}


export default faqData;